import map from 'lodash-es/map'
import React from 'react'

import { TableHeadCell } from '../TableHeadCell/TableHeadCell'
import type { TableHeader } from '../types'
import * as Styled from './styled'
import type { TableHeadProps } from './types'

export const TableHead = ({
  headers,
  sorting,
  $compact,
  hasActions,
  onHeadCellClick,
}: TableHeadProps) => {
  const renderHeadCell = (header: TableHeader) => {
    if (!header.label) return null

    return (
      <TableHeadCell
        key={header.id}
        $sortable={header.sortable || false}
        direction={sorting && sorting.headerId === header.id ? sorting.direction : undefined}
        $compact={$compact}
        $alignment={header?.alignment}
        width={header?.width}
        $minWidth={header?.minWidth}
        onClick={header.sortable ? () => onHeadCellClick(header.id) : undefined}
      >
        {header.label}
      </TableHeadCell>
    )
  }

  return (
    <Styled.Container role="rowgroup" $compact={$compact}>
      {map(headers, renderHeadCell)}
      {hasActions && <Styled.SortableCell data-testid="TableHead.SortableCell" />}
    </Styled.Container>
  )
}

export default TableHead
